import { z } from 'zod';
import { validationDocumentTypeSchema } from '../../partner-management/partner-validation/validationDocuments.js';
// Canonical form we store and return: `CHE-XXX.XXX.XXX`.
export const COMPANY_UID_REGEX = /^CHE-\d{3}\.\d{3}\.\d{3}$/;
export const companyUidSchema = z.string().regex(COMPANY_UID_REGEX);
// User input is only the 9 digits and the `CHE-` prefix is prefilled in the UI. The `.` separators
// are display-only, accepted optionally for paste convenience and stripped during normalization.
export const COMPANY_UID_INPUT_REGEX = /^\d{3}\.?\d{3}\.?\d{3}$/;
export const companyUidInputSchema = z.string().regex(COMPANY_UID_INPUT_REGEX);
// The ops tool shows the canonical UID and saves it back as it stands; the cockpit only ever sends the digits.
export const companyUidValueSchema = z.union([companyUidSchema, companyUidInputSchema]);
export const normalizeCompanyUid = (uid) => {
    const digits = uid.replace(/\D/g, '');
    return `CHE-${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}`;
};
export const validationStepSchema = z.object({
    uid: companyUidInputSchema.optional(),
});
export const onboardingValidationStatusSchema = z.enum(['validated', 'not-provided']);
// No url, because the objects sit in a private bucket and are only reachable through a short-lived signed one.
export const onboardingValidationDocumentSchema = z.object({
    uuid: z.uuid(),
    type: validationDocumentTypeSchema,
    fileName: z.string(),
    mimeType: z.string(),
    size: z.number().nullable(),
    uploadedAt: z.iso.datetime(),
});
export const validationResponseSchema = z.object({
    status: onboardingValidationStatusSchema,
    uid: companyUidSchema.optional(),
    companyName: z.string().optional(),
    documents: z.array(onboardingValidationDocumentSchema),
});
